import moment from 'moment-timezone';
import { ResultOf } from '@graphql-typed-document-node/core';
import { JobDetailsFragment } from '../jobDetailsComponents/graphql';

export function isWithinEditClockTimesWindow(
  endsTime: string | undefined | null,
  timezone: string | undefined | null,
  duration = 30,
  unit: moment.unitOfTime.DurationConstructor = 'minutes',
): boolean {
  if (!endsTime) {
    return false;
  }

  const tz = timezone || moment.tz.guess();
  const shiftEnd = moment.tz(endsTime, tz);
  const now = moment().tz(tz);
  const thirtyMinutesAfterEnd = shiftEnd.clone().add(duration, unit);

  return now.isSameOrAfter(shiftEnd) && now.isSameOrBefore(thirtyMinutesAfterEnd);
}

export function getEditClockTimesDefaultValues(job: ResultOf<typeof JobDetailsFragment>) {
  const tz = job?.location?.timezone_lookup || moment.tz.guess();
  const clockInSource = job?.approved_clock_in || job?.current_starts_time;
  const clockOutSource = job?.approved_clock_out || job?.current_ends_time;

  const clockInMoment = clockInSource ? moment.tz(clockInSource, tz) : moment.tz(moment(), tz);
  const clockOutMoment = clockOutSource ? moment.tz(clockOutSource, tz) : moment.tz(moment(), tz);

  return {
    approved_clock_in_date: clockInMoment.format('YYYY-MM-DD'),
    approved_clock_in_time: clockInMoment.format(),
    approved_clock_out_date: clockOutMoment.format('YYYY-MM-DD'),
    approved_clock_out_time: clockOutMoment.format(),
  };
}
